import { useHandler } from "@redotech/react-util/hook";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const MarkUnprintedModal = memo(function MarkUnprintedModal({
  isOpen,
  onClose,
  onConfirm,
  numSelectedGroups,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  numSelectedGroups: number;
}) {
  const [markUnprintedPending, setMarkUnprintedPending] = useState(false);
  const handleMarkUnprinted = useHandler(async () => {
    setMarkUnprintedPending(true);
    await onConfirm();
    setMarkUnprintedPending(false);
    onClose();
  });

  const primaryButton: RedoModalButtonProps = {
    text: "Mark Unprinted",
    onClick: handleMarkUnprinted,
    pending: markUnprintedPending,
  };

  const secondaryButton: RedoModalButtonProps = {
    text: "Cancel",
    onClick: onClose,
    disabled: markUnprintedPending,
    pending: false,
  };

  return (
    <RedoModal
      buttonPlacement="tight"
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title="Mark unprinted"
    >
      <Flex dir="column" gap="xl">
        <Text color="text-primary" fontSize="md">
          This action will mark {numSelectedGroups} packing slip
          {numSelectedGroups === 1 ? "" : "s"} as unprinted. Are you sure?
        </Text>
      </Flex>
    </RedoModal>
  );
});
